import { render, staticRenderFns } from "./CallDetailGrid.vue?vue&type=template&id=55966432&scoped=true&"
import script from "./CallDetailGrid.vue?vue&type=script&lang=js&"
export * from "./CallDetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./CallDetailGrid.vue?vue&type=style&index=0&id=55966432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55966432",
  null
  
)

export default component.exports